module.exports = {
          srcSet: __webpack_public_path__ + "ad8f4ed662d426d19ba677170bbe0760-58.png"+" 58w",
          images:[ {path: __webpack_public_path__ + "ad8f4ed662d426d19ba677170bbe0760-58.png",width: 58,height: 58}],
          src: __webpack_public_path__ + "ad8f4ed662d426d19ba677170bbe0760-58.png",
          toString:function(){return __webpack_public_path__ + "ad8f4ed662d426d19ba677170bbe0760-58.png"},
          
          width: 58,
          height: 58
        }